export const DEFAULT_CONTENT = {
  nav_merchandise: "Merchandise",
  nav_monster_shirts: "Monster Shirts",
  nav_login: "Login",
  hero_eyebrow: "Official Merch Store",
  hero_title_prefix: "Wear The",
  hero_title_highlight: "Chaos.",
  hero_subtitle: "Heavyweight hoodies, brutal tees and weatherproof stickers straight from the @MonsterTruckLord garage. Built loud. Built tough.",
  hero_btn_primary: "Shop Now",
  hero_btn_secondary: "Sticker Packs",
  marquee_text: "Monster Truck Lord // Ride Loud //",
  feature1_title: "Fast Shipping", feature1_text: "Orders ship within 48 hours from the garage.",
  feature2_title: "Built Tough", feature2_text: "Premium fabrics & weatherproof vinyl. No compromises.",
  feature3_title: "Fan Owned", feature3_text: "Rep the crest that flies with the MTL crew worldwide.",
  bestsellers_prefix: "Best", bestsellers_highlight: "Sellers",
  strip_tag: "Limited Time Drop", strip_prefix: "Monster", strip_highlight: "Shirts",
  strip_text: "A separate line of Monster Truck themed tees. Bold beast graphics — once they're gone, they're gone.",
  strip_btn: "Shop The Drop",
  story_prefix: "From The Pit To Your", story_highlight: "Closet.",
  story_text: "Monster Truck Lord started as a YouTube channel for the loudest, gnarliest builds on the dirt. Now the crest lives on gear you can actually wear. Every drop is designed for fans who live for the roar of a big-block engine.",
  story_btn: "Explore The Drop",
  ms_tag: "Limited Time Drop", ms_title_prefix: "Monster", ms_title_highlight: "Shirts",
  ms_subtitle: "A separate line of Monster Truck themed tees — bold beast graphics, heavyweight cotton, and screen-prints built to survive the pit. Once this drop sells out, it's gone.",
  ms_stock_note: "While stock lasts — no restocks guaranteed",
  ms_section_prefix: "The", ms_section_highlight: "Drop",
  footer_tagline: "Official merch for the @MonsterTruckLord crew. Built loud, built tough. Wear the crest, ride the chaos.",
  youtube_url: "https://youtube.com/@MonsterTruckLord",
  instagram_url: "https://instagram.com/monstertrucklord",
  facebook_url: "https://facebook.com/MonsterTruckLord",
};

// Grouped for the Admin Content editor. type: "input" (default) or "textarea"
export const CONTENT_GROUPS = [
  { group: "Navigation", fields: [
    { key: "nav_merchandise", label: "Merchandise link" },
    { key: "nav_monster_shirts", label: "Monster Shirts link" },
    { key: "nav_login", label: "Login link" },
  ]},
  { group: "Hero Section", fields: [
    { key: "hero_eyebrow", label: "Eyebrow tag" },
    { key: "hero_title_prefix", label: "Headline (white part)" },
    { key: "hero_title_highlight", label: "Headline (red part)" },
    { key: "hero_subtitle", label: "Subtitle", type: "textarea" },
    { key: "hero_btn_primary", label: "Primary button" },
    { key: "hero_btn_secondary", label: "Secondary button" },
  ]},
  { group: "Scrolling Marquee", fields: [
    { key: "marquee_text", label: "Marquee text" },
  ]},
  { group: "Feature Cards", fields: [
    { key: "feature1_title", label: "Card 1 title" }, { key: "feature1_text", label: "Card 1 text", type: "textarea" },
    { key: "feature2_title", label: "Card 2 title" }, { key: "feature2_text", label: "Card 2 text", type: "textarea" },
    { key: "feature3_title", label: "Card 3 title" }, { key: "feature3_text", label: "Card 3 text", type: "textarea" },
  ]},
  { group: "Best Sellers", fields: [
    { key: "bestsellers_prefix", label: "Heading (white part)" },
    { key: "bestsellers_highlight", label: "Heading (red part)" },
  ]},
  { group: "Homepage Monster Shirts Strip", fields: [
    { key: "strip_tag", label: "Tag" },
    { key: "strip_prefix", label: "Heading (white part)" },
    { key: "strip_highlight", label: "Heading (red part)" },
    { key: "strip_text", label: "Text", type: "textarea" },
    { key: "strip_btn", label: "Button" },
  ]},
  { group: "Brand Story", fields: [
    { key: "story_prefix", label: "Heading (white part)" },
    { key: "story_highlight", label: "Heading (red part)" },
    { key: "story_text", label: "Paragraph", type: "textarea" },
    { key: "story_btn", label: "Button" },
  ]},
  { group: "Monster Shirts Page", fields: [
    { key: "ms_tag", label: "Drop tag" },
    { key: "ms_title_prefix", label: "Title (white part)" },
    { key: "ms_title_highlight", label: "Title (red part)" },
    { key: "ms_subtitle", label: "Subtitle", type: "textarea" },
    { key: "ms_stock_note", label: "Stock note" },
    { key: "ms_section_prefix", label: "Section heading (white)" },
    { key: "ms_section_highlight", label: "Section heading (red)" },
  ]},
  { group: "Footer", fields: [
    { key: "footer_tagline", label: "Tagline", type: "textarea" },
    { key: "youtube_url", label: "YouTube URL" },
    { key: "instagram_url", label: "Instagram URL" },
    { key: "facebook_url", label: "Facebook URL" },
  ]},
];
